import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const Services: React.FC = () => {
  const services = [
    {
      id: 1,
      title: 'Prefabrik Evler',
      image: '/images/service-1.jpeg',
      description: 'Modern ve konforlu yaşam alanları için prefabrik ev çözümleri. Enerji verimli, hızlı kurulumlu ve ekonomik.',
      features: [
        'Hızlı kurulum (2-4 hafta)',
        'Enerji verimli yalıtım',
        'Özel tasarım seçenekleri',
        'Uzun ömürlü malzemeler'
      ]
    },
    {
      id: 2,
      title: 'Prefabrik Villalar',
      image: '/images/service-2.jpeg',
      description: 'Lüks ve şık villalar, özel tasarım ve yüksek kalite standartları ile hayalinizdeki yaşam alanı.',
      features: [
        'Lüks iç ve dış tasarım',
        'Geniş yaşam alanları',
        'Özel bahçe düzenlemeleri',
        'Premium malzeme seçenekleri'
      ]
    },
    {
      id: 3,
      title: 'Modül Ev',
      image: '/images/service-3.jpeg',
      description: 'Modern ve konforlu modül ev çözümleri. Hızlı kurulumlu, esnek planlama ve ekonomik yaşam alanları.',
      features: [
        'Modüler yaşam alanları',
        'Hızlı kurulum',
        'Esnek planlama',
        'Modern tasarım'
      ]
    },
    {
      id: 4,
      title: 'Endüstriyel Yapılar',
      image: '/images/project-4.jpeg',
      description: 'Fabrika, depo ve endüstriyel tesisler için geniş alanlı, dayanıklı prefabrik yapı çözümleri.',
      features: [
        'Geniş açıklıklar',
        'Yüksek dayanıklılık',
        'Hızlı üretim',
        'Özel proje çözümleri'
      ]
    },
    {
      id: 5,
      title: 'Konteyner Ev',
      image: '/images/project-5.jpeg',
      description: 'Modern ve pratik konteyner ev çözümleri. Taşınabilir, hızlı kurulumlu ve ekonomik yaşam alanları.',
      features: [
        'Taşınabilir yapı',
        'Hızlı kurulum',
        'Modern iç tasarım',
        'Ekonomik çözümler'
      ]
    },
    {
      id: 6,
      title: 'Özel Tasarım Konteyner',
      image: '/images/project-6.jpeg',
      description: 'İhtiyaçlarınıza özel tasarlanmış, benzersiz konteyner yapı çözümleri. Hayalinizdeki projeyi gerçekleştirin.',
      features: [
        'Kişiye özel tasarım',
        'Esnek planlama',
        'Yaratıcı çözümler',
        'Tam proje yönetimi'
      ]
    }
  ];

  return (
    <div className="services-page">
      <section className="services-hero">
        <div className="container">
          <h1 className="page-title">Hizmetlerimiz</h1>
          <p className="page-subtitle">
            Geniş hizmet yelpazemiz ile her türlü prefabrik yapı ihtiyacınıza 
            profesyonel çözümler sunuyoruz.
          </p>
        </div>
      </section>

      <section className="services-content section">
        <div className="container">
          <div className="services-grid">
            {services.map((service) => (
              <div key={service.id} className="service-detail-card">
                <div className="service-header">
                  <div className="service-image-large">
                    <img src={service.image} alt={service.title} loading="lazy" />
                  </div>
                  <h2 className="service-detail-title">{service.title}</h2>
                </div>
                <p className="service-detail-description">{service.description}</p>
                <ul className="service-features">
                  {service.features.map((feature, index) => (
                    <li key={index} className="service-feature-item">
                      <span className="feature-check">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
                <Link to="/iletisim" className="btn btn-primary service-btn">
                  Teklif Al
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="process-section section">
        <div className="container">
          <h2 className="section-title">Çalışma Sürecimiz</h2>
          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">1</div>
              <h3 className="step-title">Keşif ve Planlama</h3>
              <p className="step-description">
                İhtiyaçlarınızı belirliyor, proje alanını inceliyor ve 
                size özel çözümler tasarlıyoruz.
              </p>
            </div>
            <div className="process-arrow">→</div>
            <div className="process-step">
              <div className="step-number">2</div>
              <h3 className="step-title">Tasarım ve Onay</h3>
              <p className="step-description">
                Detaylı proje çizimleri hazırlıyor, onayınızı alıyor ve 
                üretim sürecine başlıyoruz.
              </p>
            </div>
            <div className="process-arrow">→</div>
            <div className="process-step">
              <div className="step-number">3</div>
              <h3 className="step-title">Üretim</h3>
              <p className="step-description">
                Modern tesislerimizde kaliteli malzemelerle üretim 
                sürecini gerçekleştiriyoruz.
              </p>
            </div>
            <div className="process-arrow">→</div>
            <div className="process-step">
              <div className="step-number">4</div>
              <h3 className="step-title">Kurulum ve Teslimat</h3>
              <p className="step-description">
                Profesyonel ekibimiz ile hızlı ve güvenli kurulum 
                yapıyor, projenizi teslim ediyoruz.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;

